function parsePositivePrice(value) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return null;
  }

  return numericValue;
}

export function getTrendReferencePrice(card = {}) {
  return parsePositivePrice(Boolean(card?.foil) ? card?.price_foil : card?.price_trend);
}

export function getCustomPriceTrendComparison(card = {}, displayedPrice = undefined, pricingMode = undefined) {
  const normalizedPricingMode = String(pricingMode ?? card?.pricing_mode ?? "").trim().toLowerCase();

  if (normalizedPricingMode !== "custom") {
    return null;
  }

  const referencePrice = getTrendReferencePrice(card);
  const currentPrice = parsePositivePrice(displayedPrice ?? card?.sale_price ?? card?.user_price);

  if (referencePrice === null || currentPrice === null) {
    return null;
  }

  const percentDelta = Math.round(((currentPrice - referencePrice) / referencePrice) * 100);

  return {
    percentDelta,
    tone: percentDelta <= 0 ? "positive" : "warning"
  };
}

export function formatCustomPriceTrendComparison(percentDelta, { compactPercent = false } = {}) {
  const numericDelta = Number(percentDelta);

  if (!Number.isFinite(numericDelta)) {
    return "";
  }

  const sign = numericDelta > 0 ? "+" : "";
  const percentSuffix = compactPercent ? "%" : " %";

  return `(${sign}${numericDelta}${percentSuffix})`;
}